import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function getSessionId() {
  let sid = localStorage.getItem('nh_session_id');
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('nh_session_id', sid);
  }
  return sid;
}

function getVisitorId() {
  let vid = localStorage.getItem('nh_visitor_id');
  if (!vid) {
    vid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('nh_visitor_id', vid);
  }
  return vid;
}

export function trackEvent(event, { reason, message, value, meta } = {}) {
  try {
    axios.post(`${API_URL}/api/track/event`, {
      event,
      reason,
      message,
      path: typeof window !== 'undefined' ? window.location.pathname : null,
      session_id: getSessionId(),
      visitor_id: getVisitorId(),
      value,
      meta,
    }).catch(() => {});
  } catch (_e) {}
}

export const trackAddToCart = (value, productId) =>
  trackEvent('add_to_cart', { value, meta: { product_id: productId } });

export const trackBeginCheckout = (value) =>
  trackEvent('begin_checkout', { value });

export const trackCheckoutError = (reason, message) =>
  trackEvent('checkout_error', { reason, message });

export const trackOrderPlaced = (value, orderNumber) =>
  trackEvent('order_placed', { value, meta: { order_number: orderNumber } });
